import script from "./AppLists.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppLists.vue?vue&type=script&setup=true&lang=ts"

import "./AppLists.vue?vue&type=style&index=0&id=d66dd8be&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d66dd8be"]])

export default __exports__